/**
 * Access
 */
export class Prevision {
  /*
   * QR
   */
  QR: string;

  /*
   * TKNUM
   */
  TKNUM: string;

  /*
   * TDLR
   */
  TDLNR: string;

  /*
   * NAME1_T
   */
  NAME1_T: string;

  /*
   * ORT01
   */
  ORT01: string;

  /*
   * STRAS
   */
  STRAS: string;

  /*
   * REGIO
   */
  REGIO: string;

  /*
   * STCD1
   */
  STCD1: string;

  /*
   * TPLST
   */
  TPLST: string;

  /*
   * VBELN
   */
  VBELN: string;

  /*
   * KUNNR
   */
  KUNNR: string;

  /*
   * NAME1
   */
  NAME1: string;

  /*
   * STRAS_WE
   */
  STRAS_WE: string;

  /*
   * PSTLZ_WE
   */
  PSTLZ_WE: string;

  /*
   * ORT01_WE
   */
  ORT01_WE: string;

  /*
   * REGIO_WE
   */
  REGIO_WE: string;

  /**
   * MATNR
   */
  MATNR: string;

  /*
   * ARKTX
   */
  ARKTX: string;

  /*
   * LFIMG
   */
  LFIMG: number;

  /*
   * GEWEI
   */
  GEWEI: string;

  /*
   * INCO1
   */
  INCO1: string;

  /*
   * INCO2
   */
  INCO2: string;

  /*
   * BSTKD
   */
  BSTKD: string;

  /*
   * ZZSILO
   */
  ZZSILO: string;

  /*
   * STTRG
   */
  STTRG: string;

  /*
   * ZZCONFLECTURA_E
   */
  ZZCONFLECTURA_E: string;

  /*
   * ZZFECHALECTURA_E
   */
  ZZFECHALECTURA_E: Date;

  /*
   * ZZHORALECTURA_E
   */
  ZZHORALECTURA_E: Date;

  /*
   * EXTI1
   */
  EXTI1: string;

  /*
   * EXTI2
   */
  EXTI2: string;

  /*
   * SIGNI
   */
  SIGNI: string;

  /*
   * ZZPENTRADA
   */
  ZZPENTRADA: number;

  /*
   * DAREG
   */
  DAREG: Date;

  /*
   * UAREG
   */
  UAREG: Date;

  /*
   * ZZPSALIDA
   */
  ZZPSALIDA: number;

  /*
   * ZZCONFLECTURA_S
   */
  ZZCONFLECTURA_S: string;

  /*
   * ZZFECHALECTURA_S
   */
  ZZFECHALECTURA_S: Date;

  /*
   * ZZHORALECTURA_S
   */
  ZZHORALECTURA_S: Date;

  /*
   * ZZMOVIL
   */
  ZZMOVIL: string;

  /*
   * LSTEL
   */
  LSTEL: string;

  /*
   * LGPBE
   */
  LGPBE: string;

  /*
   * STCEG_COMP
   */
  STCEG_COMP: string;

  /*
   * NAME1_COMP
   */
  NAME1_COMP: string;

  /*
   * NAME2_COMP
   */
  NAME2_COMP: string;

  /*
   * CITY1_COMP
   */
  CITY1_COMP: string;

  /*
   * POST_CODE1_COMP
   */
  POST_CODE1_COMP: string;

  /*
   * STREET_COMP
   */
  STREET_COMP: string;

  /*
   * CITY1_VSTEL
   */
  CITY1_VSTEL: string;

  /*
   * loadStatus
   */
  loadStatus: string;

  /*
   * loadDate
   */
  loadDate: Date;

  /*
   * access
   */
  access: any;

  /*
   * frontPlate
   */
  frontPlate: string;

  /*
   * rearPlate
   */
  rearPlate: string;

  /**
   * Create
   *
   * @param jsonData Json data
   *
   * @returns this
   */
  public static create(jsonData?) {
    const self = new this();
    Object.keys(jsonData).forEach(key => {
      self[key] = jsonData[key];
    });
    return self;
  }
}
